import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const viewCenterEnrollment = (input: { centerId: number; enrollmentId: number }) => {
  const { centerId, enrollmentId } = input
  return restApiClient
    .url(constructApiUrl(API.centers.viewCenterEnrollment.url, { id: centerId, enrollmentId }))
    .post()
}
